import { WOW } from 'wowjs';

const $animatedElements = document.querySelectorAll('.wow');

const fn = {
    init: () => {
        const wow = new WOW({
            boxClass: 'wow', // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)

            mobile: true, // trigger animations on mobile devices (default is true)
            live: true, // act on asynchronously loaded content (default is true)
        });
        wow.init();
    },
};

export default {
    can: () => $animatedElements.length,
    run: fn.init,
};
